import React, { createContext, useContext, useEffect, useState, useRef } from "react";

export const WidgetContext = createContext(null);

export const useWidgetContext = () => useContext(WidgetContext);

export const WidgetContextProvider = ({ isWidget, widgetType, settings = {}, children }) => {
    const [widgetSettings, setWidgetSettings] = useState(settings);
    const prevSettingsRef = useRef(settings);

    useEffect(() => {
        if (JSON.stringify(prevSettingsRef.current) !== JSON.stringify(settings)) {
            setWidgetSettings(settings);
            prevSettingsRef.current = settings;
        }
    }, [settings]);

    const context = {
        isWidget,
        widgetType,
        widgetSettings,
        setWidgetSettings,
    };

    return (
        <WidgetContext.Provider value={context}>
            {children}
        </WidgetContext.Provider>
    );
}
